export enum AGENCY_UTILS_TAB_KEY {
  PINCODE_MAPPING = 'agency_pincode_mapping',
  AGENCY_CAPPING = 'agency_capping'
}

export enum AGENCY_UTILS_TAB_NAME {
  PINCODE_MAPPING = 'Pincode Mapping',
  AGENCY_CAPPING = 'Agency Capping'
}
